export const ReceiverPartyData = {
  tabs: [
    {
      label: 'All Receiver Party',
      id: 1,
    },
  ],
};
